import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { HttpService } from 'src/app/core/services/http.service';
import { environment } from 'src/environments/environment';
import { HelpTextModel } from 'src/hub_schema/hubTypes';

@Injectable()
export class HelperTextService {
    private httpService: HttpService = inject(HttpService);
    private helpTexts: HelpTextModel[] = [];

    /// Returns a single HelperText record.
    /// Adds to cached helpTexts, so the same query does not get repeated
    public getHelpTextById(helpTextId: number): Observable<HelpTextModel> {
        const existingHelpText = this.helpTexts.find(ht => ht.helpTextId === helpTextId);

        if (existingHelpText) {
            return of(existingHelpText);
        }

        const url = environment.endpoints.base + '/hublov/helpText/' + helpTextId;

        return this.httpService.get<HelpTextModel>(url).pipe(
            tap((helpText: HelpTextModel) => {
                this.helpTexts.push(helpText);
            }));
    }

    /// Returns all HelperText records.
    /// Does not cache as we want the DB to be the single source of truth
    public getAllHelperTexts(): Observable<HelpTextModel[]> {
        const url = environment.endpoints.base + '/hublov/helpText/';
        return this.httpService.get<HelpTextModel[]>(url);
    }

    public saveAllHelperTexts(helperTexts: HelpTextModel[]): Observable<void> {
        const url = environment.endpoints.base + '/hublov/helpText/';
        return this.httpService.patch<void>(url, helperTexts);
    }

    public createNewHelperText(helperText: HelpTextModel): Observable<HelpTextModel> {
        const url = environment.endpoints.base + '/hublov/helpText/';
        return this.httpService.post<HelpTextModel>(url, helperText);
    }
}
